import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map, Observable, of } from "rxjs";
import { URLConfig } from "../../configs/url-config";
import { NbMenuItem, NbToastrService } from "@nebular/theme";
import { MENU_ITEMS } from "../pages/pages-menu";
 

@Injectable({
  providedIn: "root"
})
export class ApiService {
   private permissions: string[] = [];      // store user permissions
  private roles: string[] = [];
  constructor(private http: HttpClient,
    private toastrService: NbToastrService) { }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "multipart/form-data;"
    })
  };
  httpOptionsPost = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      'accept': 'application/json',
    })
  };
   

  post(url: any, dataModel: any) {
    return this.http.post(url, dataModel, this.httpOptionsPost);
  }
postWithoutInterceptor(url: any, dataModel: any, token?: string) {
  let headers = new HttpHeaders({
    'skip-interceptor': 'true'
  });

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return this.http.post(url, dataModel, { headers });
}


  getRequest<T>(url: string): Observable<T> {
    return this.http.get<T>(url);
  }
getWithoutInterceptorWithToken<T>(url: string, token: string): Observable<T> {
  return this.http.get<T>(url, {
    headers: {
      skipInterceptor: 'true',
      Authorization: `Bearer ${token}`
    }
  });
}


  getRequestWithParams<T>(url: string, params: any): Observable<T> {
    return this.http.get<T>(url, { params: params });
  }
  getItemDetail<T>(url: string, params: any): Observable<T> {
    return this.http.get<T>(url, { params: params });
  }

  postRequest<T>(url: string, dataModel: any): Observable<T> {
    return this.http.post<T>(url, dataModel);
  }
  postRequestWithParams(url: string, paramsObj: any): Observable<any> {
  let params = new HttpParams();

  Object.keys(paramsObj).forEach(key => {
    params = params.set(key, paramsObj[key]);
  });

  return this.http.post(url, null, { params });
}


  postFormDataRequest(url: any, dataModel: any) {
    return this.http.post(url, dataModel, this.httpOptions);
  }

  patchRequest(url: any, dataModel: any) {
    return this.http.patch(url, dataModel);
  }

  putRequest(url: any, dataModel: any) {
    return this.http.put(url, dataModel);
  }

  putFormDataRequest(url: any, dataModel: any) {
    return this.http.put(url, dataModel, this.httpOptions);
  }

  async verifyToken(url: any, dataModel: any) {
    return await this.http.post(url, dataModel).toPromise();
  }

  deleteRequest(url: any,params: any) {
    return this.http.delete(url,{ params: params });
  }

  deleteRequestbody(url: any,params: any) {
    return this.http.delete(url,{body: params });
  }

  getValueLocalstorage(){
    return  JSON.parse(localStorage.getItem('user'))
  }
  getValueLocalEmail(){
    return  localStorage.getItem('resetEmail')
  }

  
  success(param): void {
    this.toastrService.success(`${param}`, 'Success');
  }

  error(param): void {
    this.toastrService.danger(`${param}`, 'Error');
  }

  warning(param): void {
    this.toastrService.warning(`${param}`, 'Warning');
  }
  primary(param): void {
    this.toastrService.primary(`${param}`, 'Info');
  }

  info(param): void {
    this.toastrService.info(`${param}`, 'Info');
  }
   getCurrentUser(): any {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }

  isSuperAdmin(): boolean {
    const user = this.getCurrentUser();
    return user?.role === 'SuperAdmin';
  }

  isAdmin(): boolean {
    const user = this.getCurrentUser();
    return user?.role === 'Admin';
  }

  getSchoolId(): number | null {
    const user = this.getCurrentUser();
    if (this.isAdmin()) {
      return user.schoolId || null;
    }
    return null;
  }
   loadRolesPermissions(userId: number) {
    return this.http.get(URLConfig.getUserRoles + '?userId=' + userId).pipe(
      map((res: any) => {
        this.roles = res.data.map((x: any) => x.role.role.toLowerCase());
        this.permissions = res.data
          .flatMap((r: any) =>
            r.permissions.map((p: any) => p.permission.userPermission)
          )
          .map((p: string) => p.toLowerCase());

        return true;
      })
    );
  }
can(permission: string): boolean {
  if (this.isSuperAdmin()) return true;
  return this.permissions.includes(permission.toLowerCase());
}
  canAny(permissionList: string[]): boolean {
    return permissionList.some((p) =>
      this.permissions.includes(p.toLowerCase())
    );
  }
 getFilteredMenu(): Observable<NbMenuItem[]> {
  const currentUser = this.getCurrentUser();
  if (!this.isAdmin()) {
    return of(MENU_ITEMS);
  }
  return this.loadRolesPermissions(currentUser.id).pipe(
    map(() => {
      const filterTargets = ['schools', 'students', 'access control', 'q&a'];
      const onlyTargets = MENU_ITEMS.filter(item =>
        filterTargets.includes(item.title.toLowerCase())
      );
      return onlyTargets.filter(item =>
        this.roles.includes(item.title.toLowerCase())
      );
    })
  );
}

}
